import React from 'react'
import {
  Route,
  Switch,
  Redirect,
  BrowserRouter as Router
} from 'react-router-dom'

import axios from 'axios'
import {WindowURL,WindowURLAdmin, WindowURLClient} from './component/config/settings'

import 'semantic-ui-css/semantic.min.css'
import 'animate.css'
import './assets/css/calendar.css'
import './assets/css/react-datepicker.css'
import '@fullcalendar/core/main.css'
import '@fullcalendar/daygrid/main.css'
import './assets/css/dropzone.css'
import './assets/css/unicons.css'
import './assets/css/style.css'

import AppAdmin from './component/admin/root'
import AdminLogin from './component/admin/inc/login'

import AppClient from './component/client/root'
import AppApplication from './component/application/root'

axios.defaults.baseURL = 'https://primecapitalmarkets.net/api'

const NoMatch = ({ location }) => (
  <div>
    <h3>No match for <code>{location.pathname}</code></h3>
  </div>
)

function App() {
  return (
    <Router>
        <Switch>

          {/* Application */}
          <Route exact path={WindowURL('/')} component={AppApplication}/>
          <Route exact path={WindowURL('/member-login')} component={AppApplication}/>
          <Route exact path={WindowURL('/account-login')} component={AppApplication}/>
          <Route exact path={WindowURL('/account-type')} component={AppApplication}/>
          <Route exact path={WindowURL('/individual-account')} component={AppApplication}/>
          <Route exact path={WindowURL('/joint-account')} component={AppApplication}/>
          <Route exact path={WindowURL('/financials')} component={AppApplication}/>
          <Route exact path={WindowURL('/attach-document')} component={AppApplication}/>

          {/* Client Dashboard */}
          <Route exact path={WindowURLClient('/')} component={AppClient}/>
          <Route exact path={WindowURLClient('/account')} component={AppClient}/>
          <Route exact path={WindowURLClient('/tradingbuy')} component={AppClient}/>
          <Route exact path={WindowURLClient('/tradingsell')} component={AppClient}/>
          <Route exact path={WindowURLClient('/trade-order')} component={AppClient}/>
          <Route exact path={WindowURLClient('/funding-record')} component={AppClient}/>
          <Route exact path={WindowURLClient('/funding-transfer')} component={AppClient}/>
          <Route exact path={WindowURLClient('/change-password')} component={AppClient}/>
          <Route exact path={WindowURLClient('/help-desk')} component={AppClient}/>


          {/* Admin Dashboard */}
          <Route exact path={WindowURLAdmin('/')} component={AppAdmin}/>

          <Route exact path={WindowURLAdmin('/login')} component={AdminLogin}/>
          <Route exact path={WindowURLAdmin('/account/list')} component={AppAdmin}/>
          <Route exact path={WindowURLAdmin('/account/edit/:id')} component={AppAdmin}/>
          <Route exact path={WindowURLAdmin('/account/approval/:id')} component={AppAdmin}/>

          <Route exact path={WindowURLAdmin('/tradingbuy')} component={AppAdmin}/>
          <Route exact path={WindowURLAdmin('/tradingbuy/:id')} component={AppAdmin}/>
          <Route exact path={WindowURLAdmin('/tradingsell')} component={AppAdmin}/>
          <Route exact path={WindowURLAdmin('/tradingsell/:id')} component={AppAdmin}/>
          <Route exact path={WindowURLAdmin('/funding-record')} component={AppAdmin}/>
          <Route exact path={WindowURLAdmin('/funding-record/:id')} component={AppAdmin}/>
          <Route exact path={WindowURLAdmin('/funding-transfer')} component={AppAdmin}/>
          <Route exact path={WindowURLAdmin('/funding-transfer/:id')} component={AppAdmin}/>

          <Route exact path={WindowURLAdmin('/salesrep')} component={AppAdmin}/>
          <Route exact path={WindowURLAdmin('/salesrep/:id')} component={AppAdmin}/>
          <Route exact path={WindowURLAdmin('/users')} component={AppAdmin}/>
          <Route exact path={WindowURLAdmin('/users/:id')} component={AppAdmin}/>

          <Route component={NoMatch} />

        </Switch>
    </Router>
  );
}

export default App;
